import Color from '@bubble-dev/fantasy-color';
import { createConstantColorDeprecated } from './helpers';
var deprecation = {
  removalDate: 'v5.0.0'
};
/**
 * @deprecated this brand color is outdated and will be removed with v5.0.0
 */

export var brandPancakeKlarnaPink = createConstantColorDeprecated('brandPancakeKlarnaPink', deprecation, new Color('#FFB3C7'));
/**
 * @deprecated this brand color is outdated and will be removed with v5.0.0
 */

export var brandPancakeKlarnaBlack = createConstantColorDeprecated('brandPancakeKlarnaBlack', deprecation, new Color('#17120F'));
/**
 * @deprecated this brand color is outdated and will be removed with v5.0.0
 */

export var brandPancakeKlarnaWhite = createConstantColorDeprecated('brandPancakeKlarnaWhite', deprecation, new Color('#FFFFFF'));
/**
 * @deprecated this brand color is outdated and will be removed with v5.0.0
 */

export var brandPancakeSmooothYellow = createConstantColorDeprecated('brandPancakeSmooothYellow', deprecation, new Color('#FFF673'));
/**
 * @deprecated this brand color is outdated and will be removed with v5.0.0
 */

export var brandPancakeSmooothYellowBlocks = createConstantColorDeprecated('brandPancakeSmooothYellowBlocks', deprecation, new Color('#FFF999'));
/**
 * @deprecated this brand color is outdated and will be removed with v5.0.0
 */

export var brandPancakeSmooothGreen = createConstantColorDeprecated('brandPancakeSmooothGreen', deprecation, new Color('#80FFA6'));
/**
 * @deprecated this brand color is outdated and will be removed with v5.0.0
 */

export var brandPancakeSmooothGreenBlocks = createConstantColorDeprecated('brandPancakeSmooothGreenBlocks', deprecation, new Color('#9EFFBB'));
/**
 * @deprecated this brand color is outdated and will be removed with v5.0.0
 */

export var brandPancakeSmooothBlue = createConstantColorDeprecated('brandPancakeSmooothBlue', deprecation, new Color('#73F5FF'));
/**
 * @deprecated this brand color is outdated and will be removed with v5.0.0
 */

export var brandPancakeSmooothBlueBlocks = createConstantColorDeprecated('brandPancakeSmooothBlueBlocks', deprecation, new Color('#99F8FF'));
/**
 * @deprecated this brand color is outdated and will be removed with v5.0.0
 */

export var brandPancakeVanilla = createConstantColorDeprecated('brandPancakeVanilla', deprecation, new Color('#FFFAB0'));
/**
 * @deprecated this brand color is outdated and will be removed with v5.0.0
 */

export var brandPancakeVanillaLight = createConstantColorDeprecated('brandPancakeVanillaLight', deprecation, new Color('#FFFCC9'));
/**
 * @deprecated this brand color is outdated and will be removed with v5.0.0
 */

export var brandPancakeMint = createConstantColorDeprecated('brandPancakeMint', deprecation, new Color('#B8FFCC'));
/**
 * @deprecated this brand color is outdated and will be removed with v5.0.0
 */

export var brandPancakeMintLight = createConstantColorDeprecated('brandPancakeMintLight', deprecation, new Color('#D1FFE0'));
/**
 * @deprecated this brand color is outdated and will be removed with v5.0.0
 */

export var brandPancakePool = createConstantColorDeprecated('brandPancakePool', deprecation, new Color('#B3F9FF'));
/**
 * @deprecated this brand color is outdated and will be removed with v5.0.0
 */

export var brandPancakePoolLight = createConstantColorDeprecated('brandPancakePoolLight', deprecation, new Color('#CCFCFF'));
/**
 * @deprecated this brand color is outdated and will be removed with v5.0.0
 */

export var brandPancakeLavender = createConstantColorDeprecated('brandPancakeLavender', deprecation, new Color('#E9D6FF'));
/**
 * @deprecated this brand color is outdated and will be removed with v5.0.0
 */

export var brandPancakeLavenderLight = createConstantColorDeprecated('brandPancakeLavenderLight', deprecation, new Color('#F0E3FF'));
/**
 * @deprecated this brand color is outdated and will be removed with v5.0.0
 */

export var brandPancakeSky = createConstantColorDeprecated('brandPancakeSky', deprecation, new Color('#BDD5FF'));
/**
 * @deprecated this brand color is outdated and will be removed with v5.0.0
 */

export var brandPancakeSkyLight = createConstantColorDeprecated('brandPancakeSkyLight', deprecation, new Color('#D1E2FF'));
/**
 * @deprecated this brand color is outdated and will be removed with v5.0.0
 */

export var brandPancakePeach = createConstantColorDeprecated('brandPancakePeach', deprecation, new Color('#FFD7AD'));
/**
 * @deprecated this brand color is outdated and will be removed with v5.0.0
 */

export var brandPancakePeachLight = createConstantColorDeprecated('brandPancakePeachLight', deprecation, new Color('#FFE6CC'));
//# sourceMappingURL=pancakeBrandColors.js.map